jQuery(document).ready(function ($) {
  $('[data-name="download_form_data"] input[type="radio"]').on(
    "click",
    function () {
      if ($(this).val() === "nnm_download_form_data") {
        file_url = admin_custom_obj.file_url;
        window.open(admin_custom_obj.file_url, "_blank");
      }
    }
  );
});
